import { Helmet } from "react-helmet";
import BlogsLayout from "../sections/blogs/blogsLayout";

const BlogsPage = () => {
    return (
        <>
            <Helmet>
                <title>code3x Blog | Insights on AI, Games & Digital Solutions</title>
                <meta name="description" content="Explore articles, tips, and stories from code3x experts in AI, games, and digital solutions." />
                <meta name="keywords" content="code3x blog, AI articles, game development tips, digital solutions insights, technology blog, innovation trends, leading tech company, Sri Lanka" />
                <link rel="canonical" href="https://code3x.tech/blogs" />
            </Helmet>

            <BlogsLayout />
        </>
    );
}

export default BlogsPage;